// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-creation-container-row {
  box-shadow: 0px 1px 2px -1px #0000001a;
  box-shadow: 0px 1px 3px 0px #0000001a;
  border-bottom-width: 1px;
  border-bottom-width: 1px;
  background: #ffffff;
  border-bottom: 1px solid #f3f4f6;
  border-top: 1px solid #f3f4f6;
}
/* Active step text */
.workflow-stepper
  .ant-steps-item.ant-steps-item-process
  .ant-steps-item-title
  .campaign-step-title {
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  color: #d2042d !important;
}

/* Active info icon */
.workflow-stepper
  .ant-steps-item.ant-steps-item-process
  .campaign-step-info-icon {
  color: #d2042d !important;
  font-size: 16px !important;
}

/* Completed step */
.workflow-stepper .ant-steps-item.ant-steps-item-finish .campaign-step-title {
  font-family: sans-serif !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  color: #d2042d !important;
}

/* Upcoming steps */
.workflow-stepper .ant-steps-item.ant-steps-item-wait .campaign-step-title {
  font-family: sans-serif !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  color: #98a2b3 !important;
}
/* Hide Ant Design default step numbers/icons */
.campaign-creation-stepper .ant-steps-item-icon {
  display: none !important;
}

/* Remove the space reserved for the number/icon */
.campaign-creation-stepper .ant-steps-item-content {
  margin-inline-start: 0 !important;
}

.workflow-stepper .ant-steps {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  gap: 5%;
}

.campaign-creation-stepper .ant-steps-item {
  flex: none !important;
}
.campaign-creation-stepper .ant-steps-item-process {
  position: relative;
}

.campaign-creation-stepper .ant-steps-item-process::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: #d2042d;
}
@media ((max-width: 1024px)) {
  .workflow-stepper {
    width: 100%;
    padding: 20px;
    background: #fff;
  }
  .workflow-stepper .ant-steps {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    gap: 7px;
    overflow-x: scroll;
  }
  .messages-main-card {
    width: 100% !important;
    height: 69vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/campaign-creation/CampaignCreationSteps.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;AAC/B;AACA,qBAAqB;AACrB;;;;EAIE,2CAA2C;EAC3C,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;;;EAGE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA,+CAA+C;AAC/C;EACE,wBAAwB;AAC1B;;AAEA,kDAAkD;AAClD;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;AACT;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;AACA;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,YAAY;EACd;AACF","sourcesContent":[".campaign-creation-container-row {\n  box-shadow: 0px 1px 2px -1px #0000001a;\n  box-shadow: 0px 1px 3px 0px #0000001a;\n  border-bottom-width: 1px;\n  border-bottom-width: 1px;\n  background: #ffffff;\n  border-bottom: 1px solid #f3f4f6;\n  border-top: 1px solid #f3f4f6;\n}\n/* Active step text */\n.workflow-stepper\n  .ant-steps-item.ant-steps-item-process\n  .ant-steps-item-title\n  .campaign-step-title {\n  font-family: \"Inter\", sans-serif !important;\n  font-weight: 600 !important;\n  font-size: 16px !important;\n  line-height: 20px !important;\n  color: #d2042d !important;\n}\n\n/* Active info icon */\n.workflow-stepper\n  .ant-steps-item.ant-steps-item-process\n  .campaign-step-info-icon {\n  color: #d2042d !important;\n  font-size: 16px !important;\n}\n\n/* Completed step */\n.workflow-stepper .ant-steps-item.ant-steps-item-finish .campaign-step-title {\n  font-family: sans-serif !important;\n  font-weight: 600 !important;\n  font-size: 16px !important;\n  color: #d2042d !important;\n}\n\n/* Upcoming steps */\n.workflow-stepper .ant-steps-item.ant-steps-item-wait .campaign-step-title {\n  font-family: sans-serif !important;\n  font-weight: 400 !important;\n  font-size: 16px !important;\n  color: #98a2b3 !important;\n}\n/* Hide Ant Design default step numbers/icons */\n.campaign-creation-stepper .ant-steps-item-icon {\n  display: none !important;\n}\n\n/* Remove the space reserved for the number/icon */\n.campaign-creation-stepper .ant-steps-item-content {\n  margin-inline-start: 0 !important;\n}\n\n.workflow-stepper .ant-steps {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  gap: 5%;\n}\n\n.campaign-creation-stepper .ant-steps-item {\n  flex: none !important;\n}\n.campaign-creation-stepper .ant-steps-item-process {\n  position: relative;\n}\n\n.campaign-creation-stepper .ant-steps-item-process::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 2px;\n  background: #d2042d;\n}\n@media ((max-width: 1024px)) {\n  .workflow-stepper {\n    width: 100%;\n    padding: 20px;\n    background: #fff;\n  }\n  .workflow-stepper .ant-steps {\n    display: flex;\n    align-content: center;\n    align-items: center;\n    justify-content: flex-start;\n    flex-direction: row;\n    gap: 7px;\n    overflow-x: scroll;\n  }\n  .messages-main-card {\n    width: 100% !important;\n    height: 69vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
